import { toneOf } from "./crmHelpers";
import { formatMoney, formatNumber } from "./crmHelpers";

/*
  Mistura das filas: onde o trabalho do dia está concentrado.

  Uma barra empilhada em vez de um gráfico de pizza. Pizza é a forma errada
  para isto por duas razões: comparar ângulos é mais difícil que comparar
  comprimentos, e aqui há oito filas — uma pizza de oito fatias vira um disco
  de confete onde nada se lê.

  Cada segmento é clicável e filtra a lista abaixo: o gráfico não é só
  ilustração, é o controle de filtro da tela.
*/

const QueueMix = ({ queues, selected, onSelect, total }) => {
  const comTrabalho = queues.filter((queue) => queue.count > 0);

  if (!comTrabalho.length || !total) return null;

  return (
    <div>
      <div className="flex h-8 w-full gap-[2px] overflow-hidden rounded-xl">
        {comTrabalho.map((queue) => {
          const ativo = selected === queue.id;
          const largura = (queue.count / total) * 100;

          return (
            <button
              key={queue.id}
              type="button"
              onClick={() => onSelect(ativo ? "all" : queue.id)}
              title={`${queue.label}: ${queue.count} conta(s) — ${queue.why}`}
              style={{ width: `${largura}%` }}
              className={`group relative flex min-w-[26px] items-center justify-center transition ${
                toneOf(queue.tone).bar
              } ${
                selected !== "all" && !ativo
                  ? "opacity-30 hover:opacity-60"
                  : "hover:brightness-95"
              }`}
            >
              <span className="text-[11px] font-bold text-white/95">
                {queue.count}
              </span>
            </button>
          );
        })}
      </div>

      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1">
        {comTrabalho.map((queue) => (
          <button
            key={queue.id}
            type="button"
            onClick={() => onSelect(selected === queue.id ? "all" : queue.id)}
            className={`flex items-center gap-1.5 text-[11px] transition ${
              selected === queue.id
                ? "font-semibold text-slate-900"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            <span
              className={`h-2 w-2 shrink-0 rounded-full ${toneOf(queue.tone).dot}`}
            />
            {queue.label}
            <span className="text-slate-400">{formatNumber(queue.count)}</span>
            {queue.valueAtStake > 0 ? (
              <span className="text-amber-700">
                {formatMoney(queue.valueAtStake)}
              </span>
            ) : null}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QueueMix;
